// extracted by mini-css-extract-plugin
export default {"button":"style_button__DTU82"};